const validateSelectedChoices = (state, action) => {
  const designClassification = action?.payload?.designClassification;
  const { options, choices } = state;

  const updatedChoices = { ...choices };

  if (designClassification === 'postform') {
    const customSplashesOption = Object.values(options).find((option) =>
        option.tags?.some((tag) => tag.toLowerCase() === 'countertops-custom-splashes'));

    if (customSplashesOption) {
      (customSplashesOption.choices || []).forEach((choiceId) => {
        if (updatedChoices[choiceId]?.isSelected) {
          updatedChoices[choiceId] = {
            ...updatedChoices[choiceId],
            isSelected: false,
          };
        }
      });
    }
  } else if (designClassification === 'custom') {
    const postFormEndSplashesOption = Object.values(options).find((option) =>
        option.tags?.some((tag) => tag.toLowerCase() === 'countertops-postform-endsplashes'));

    if (postFormEndSplashesOption) {
      (postFormEndSplashesOption.choices || []).forEach((choiceId) => {
        if (updatedChoices[choiceId]?.isSelected) {
          updatedChoices[choiceId] = {
            ...updatedChoices[choiceId],
            isSelected: false,
          };
        }
      });
    }
  }

  return {
    ...state,
    choices: updatedChoices,

  };
};

export default validateSelectedChoices;